<div class="p-grid" style="padding:15px">
    <p-panel  header="ECHANTILLONNAGE ISO" class="p-col-12" styleClass="cq"  [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <app-iso></app-iso>
    </p-panel> 
 
    <p-panel  header="ECHANTILLONNAGE CIBLE" class="p-col-12" styleClass="cq"  [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <app-complexite></app-complexite>
    </p-panel>
     

    
</div>



